export const zIndexStyle = {
  base: 1,
  nav: 2,
  floating: 1000,
};
